import axios from '@/axios'

const dailideposit = {
  // 判断该用户是否实名
  async isIdentityInfo(params) {
    return await axios.post('/uc/depositRg/accountInfo', params, {
      des: '判断该用户是否实名',
      sTime: new Date().getTime(),
    })
  },
  

  //基础认证
  async foundationIdentityInfoSubmit(params) {
    return await axios.post('/uc/user/userinfo/foundationIdentityInfoSubmit', params, { des: '基础认证', sTime: new Date().getTime() })
  },
}

export default dailideposit



// WEBPACK FOOTER //
// ./src/api/dailideposit.js